/**
 * @description
 * Image is usually only visual representation and therefore is hidden from screen readers.
 *
 * @specification
 * Adds attribute 'aria-hidden=true', if there is no 'alt' property provided.
 */
var imageBehavior = function (props) { return ({
    attributes: {
        root: {
            'aria-hidden': props['alt'] ? undefined : 'true',
        },
    },
}); };
export default imageBehavior;
